module.exports = __webpack_public_path__ + "img/guizhouHints_10.ef1c58bb.jpg";